import type { responseResolvers } from './resolvers.d';
import { resolve206 } from './206';

export const resolversMapper: { [key: number]: responseResolvers } = {
  206: resolve206,
};
